import { createSlice } from '@reduxjs/toolkit';
import { IInitialMyReportsListState } from './types';

const SLICE_NAME = 'MY_REPORTS_SLICE';

export const initialState: IInitialMyReportsListState = {
  loading: false,
  error: '',
  data: { items: [], nextToken: null },
};

const userSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchMyReportsError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchMyReports: (state) => {
      state.loading = true;
      state.error = '';
    },
    fetchMyReportsSearch: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchMyReportsEnhancedSearch: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchMyReportsSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
  },
});

export default userSlice;
